export const UPDATE_SUBTITLES = 'UPDATE_SUBTITLES';
